import { render } from "./UsersListView.vue?vue&type=template&id=2b93c4df&scoped=true"
import script from "./UsersListView.vue?vue&type=script&lang=js"
export * from "./UsersListView.vue?vue&type=script&lang=js"

import "./UsersListView.vue?vue&type=style&index=0&id=2b93c4df&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b93c4df"]])

export default __exports__